// removed by extract-text-webpack-plugin
module.exports = {"vpMediaDisplay":"vpMediaDisplay___35jKU","vpTitleStyle":"vpTitleStyle___15_nk","vpHeaderDetailsStyle":"vpHeaderDetailsStyle___2no2W","vpDisplayDialogContent":"vpDisplayDialogContent___1-9Sr","vpTextStyles":"vpTextStyles___3FDBG","vpDisplayDialogDetailsSection":"vpDisplayDialogDetailsSection___GoGw4","vpDetailsDisplayContextSections":"vpDetailsDisplayContextSections___3tff2","vpMediaDetailsSkeletonList":"vpMediaDetailsSkeletonList___3niv5","vpMediaDetailsSkeletonTable":"vpMediaDetailsSkeletonTable___2umuA"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaSubmissionDetailsDialog.module.less
// module id = 3559
// module chunks = 29